/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : CustomSpinner.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import { Box, Dialog } from "@mui/material";
import React from "react";
import PropTypes from "prop-types";

function CustomLoaderDialog(props) {
  return (
    <Dialog open={props.open}>
      <Box
        sx={{
          marginTop: "10px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: "25px",
        }}
      >

        <img
          style={{
            height: "150px",
            width: "200px",
            padding: "-20px",

            borderRadius: "10px",
          }}
          src={require("../../assets/gif-files/logogif.gif")}
          alt="loading..."
        />
      </Box>
    </Dialog>
  );
}

CustomLoaderDialog.propTypes = {
  open: PropTypes.bool,
};

export default CustomLoaderDialog;
